export const COMPANY_SWITCHER_MODAL_KEY = 'company-switcher'
